<template>
  <v-card>
    <v-card-title class="headline font-weight-bold grey--text flex-nowrap">
      Cuéntanos que estás buscando
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text :class="`${$vuetify.breakpoint.smAndDown ? 'px-0' : ''}`">
      <v-stepper v-model="e1" class="elevation-0" vertical>
        <v-stepper-step :complete="e1 > 1" step="1" editable>
          <span class="title font-weight-light primary--text">Título</span>
        </v-stepper-step>
        <v-stepper-content
          :class="`${$vuetify.breakpoint.smAndDown ? 'pt-0 pl-0 pr-10' : ''}`"
          step="1"
        >
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-1">
                <BaseMyTextField
                  v-model="notice.titulo"
                  label="Puesto/Título del Aviso *"
                  :error-messages="tituloErrors"
                  @input="$v.notice.titulo.$touch()"
                  @blur="$v.notice.titulo.$touch()"
                  required
                ></BaseMyTextField>
              </v-col>
              <v-col cols="12" class="pb-1">
                <span
                  :class="descripcionValid ? 'grey--text body-2':'red--text body-2'"
                >Descripción *</span>
                <vue-editor
                  v-model="notice.descripcion"
                  @focus="descripcionChange"
                  @blur="descripcionChange"
                  @text-change="descripcionChange"
                  :editorToolbar="customToolbar"
                ></vue-editor>
                <span class="red--text caption" v-if="!descripcionValid">Campo obligatorio</span>
              </v-col>
              <v-col cols="12" class="pb-1">
                <v-sheet>
                  <v-switch
                    v-model="notice.permitir_discapacitados"
                    inset
                    label="Este trabajo es apto para persona con discapacidad"
                  ></v-switch>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <v-stepper-step :complete="e1 > 2" step="2" editable>
          <span
            :class="
                [
                  'title',
                  'font-weight-light',
                  { 'primary--text': e1 === 2 || e1 > 2 }
                ]"
          >Información</span>
        </v-stepper-step>
        <v-stepper-content
          :class="`${$vuetify.breakpoint.smAndDown ? 'pt-0 pl-0 pr-10' : ''}`"
          step="2"
        >
          <v-container>
            <v-row>
              <v-col cols="12" md="4" class="pb-1">
                <BaseMyTextField
                  v-model="notice.pais"
                  label="Pais *"
                  disabled
                  :error-messages="paisErrors"
                  @input="$v.notice.pais.$touch()"
                  @blur="$v.notice.pais.$touch()"
                  required
                ></BaseMyTextField>
              </v-col>
              <v-col cols="12" md="4" class="pb-1">
                <BaseMySelect
                  v-model="notice.provincia"
                  :items="provinces"
                  label="Provincia *"
                  item-text="name"
                  menu-props="auto"
                  :error-messages="provinciaErrors"
                  @input="$v.notice.provincia.$touch()"
                  @blur="$v.notice.provincia.$touch()"
                  @change="notice.ciudad = ''; retriveCities(notice.pais, notice.provincia);"
                  required
                ></BaseMySelect>
              </v-col>
              <v-col cols="12" md="4" class="pb-1">
                <BaseMySelect
                  v-model="notice.ciudad"
                  :items="cities"
                  label="Ciudad *"
                  :error-messages="ciudadErrors"
                  item-text="name"
                  menu-props="auto"
                  @input="$v.notice.ciudad.$touch()"
                  @blur="$v.notice.ciudad.$touch()"
                  required
                ></BaseMySelect>
              </v-col>
              <v-col cols="12" md="4" class="pb-1">
                <BaseMyTextField
                  v-model="notice.direccion"
                  label="Dirección"
                ></BaseMyTextField>
              </v-col>
              <v-col cols="12" md="4" class="pb-1">
                <BaseMySelect
                  v-model="notice.area"
                  label="Area *"
                  :items="workAreas"
                  item-text="area"
                  menu-props="auto"
                  :error-messages="areaErrors"
                  @input="$v.notice.area.$touch()"
                  @blur="$v.notice.area.$touch()"
                  required
                ></BaseMySelect>
                  <!-- @change="notice.subarea = ''; retrieveSubarea(notice.area);" -->
              </v-col>
              <!-- <v-col cols="12" md="4" class="pb-1">
                <BaseMySelect
                  v-model="notice.subarea"
                  menu-props="auto"
                  label="Subárea *"
                  :items="subareas"
                  :error-messages="subareaErrors"
                  @input="$v.notice.subarea.$touch()"
                  @blur="$v.notice.subarea.$touch()"
                  required
                ></BaseMySelect>
              </v-col> -->
              <!-- <v-col cols="12" md="5" class="pb-1">
                <BaseMySelect
                  v-model="notice.nivel"
                  label="Nivel *"
                  :items="levels"
                  :error-messages="nivelErrors"
                  @input="$v.notice.nivel.$touch()"
                  @blur="$v.notice.nivel.$touch()"
                  required
                ></BaseMySelect>
              </v-col> -->
              <v-col cols="12" md="4" class="pb-1">
                <BaseMySelect
                  v-model="notice.tipo_trabajo"
                  label="Tipo de Empleo *"
                  :items="jobTypes"
                  :error-messages="tipoTrabajoErrors"
                  @input="$v.notice.tipo_trabajo.$touch()"
                  @blur="$v.notice.tipo_trabajo.$touch()"
                  required
                ></BaseMySelect>
              </v-col>
              <v-col cols="12" md="3" class="pb-1">
                <BaseMyTextField
                  v-model="notice.vacantes"
                  type="number"
                  min="0"
                  label="Vacantes *"
                  :error-messages="vacantesErrors"
                  @input="$v.notice.vacantes.$touch()"
                  @blur="$v.notice.vacantes.$touch()"
                  required
                ></BaseMyTextField>
              </v-col>
              <v-col cols="12" md="4" class="pb-1">
                <BaseMySelect
                  v-model="questionTypeSelected"
                  label="Tipo de pregunta"
                  required
                  :items="questionType"
                ></BaseMySelect>
              </v-col>
              <v-col
                cols="12"
                md="8"
                class="pb-1 d-flex align-center"
                v-if="questionTypeSelected === 'Predefinida'"
              >
                <BaseMySelect
                  v-model="questionToAdd"
                  class="mr-2"
                  label="Pregunta predefinida"
                  required
                  :items="predefinedQuestionsFiltered"
                ></BaseMySelect>
              </v-col>
              <v-col class="pb-1" cols="12" md="8" v-if="questionTypeSelected === 'Abierta'">
                <BaseMyTextField v-model="questionToAdd" label="Pregunta abierta"></BaseMyTextField>
              </v-col>
              <template v-if="questionTypeSelected === 'Opción multiple'">
                <v-col class="py-0" cols="12">
                  <BaseMyTextField v-model="questionToAdd" label="Pregunta"></BaseMyTextField>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-list>
                    <v-subheader>OPCIONES</v-subheader>
                    <template v-for="(option, index) in multipleOptions">
                      <v-list-item>
                        <BaseMyTextField
                          v-model="multipleOptions[index]"
                          class="pt-1"
                          :prepend-icon="`mdi-numeric-${index + 1}`"
                          :append-icon="index > 1 ? 'mdi-close' : ''"
                          @click:append="multipleOptions.splice(index, 1)"
                        ></BaseMyTextField>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </template>
              <v-col
                cols="12"
                class="py-0 d-flex justify-end"
                v-if="questionTypeSelected !== 'Sin preguntas'"
              >
                <v-btn
                  :disabled="multipleOptions.length === 10"
                  class="mb-2 mr-2"
                  color="info"
                  v-if="questionTypeSelected === 'Opción multiple'"
                  @click="addMultipleOption"
                >Agregar Opción</v-btn>
                <v-btn class="mb-2 mr-2" color="error" @click="cancelAddQuestion">
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
                <v-btn
                  @click="addQuestion"
                  class="mb-2"
                  color="success"
                  :disabled="!questionToAdd || !multipleOptionValidation"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <v-col class="pt-0" cols="12" v-if="notice.preguntas.length > 0">
                <v-list>
                  <v-subheader class="title font-weight-light primary--text">PREGUNTAS</v-subheader>
                  <template v-for="(pregunta, index) in notice.preguntas">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{pregunta.pregunta}}
                          <v-btn color="error" icon @click="notice.preguntas.splice(index, 1)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{pregunta.tipo}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < notice.preguntas.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <v-stepper-step :complete="e1 > 2" step="3" editable>
          <span
            :class="
                [
                  'title',
                  'font-weight-light',
                  { 'primary--text': e1 === 3 || e1 > 2 }
                ]"
          >Requisitos del Puesto (Opcional)</span>
        </v-stepper-step>
        <v-stepper-content
          :class="`${$vuetify.breakpoint.smAndDown ? 'pt-0 pl-0 pr-10' : ''}`"
          step="3"
        >
          <v-container class="pt-0">
            <v-row>
              <v-col cols="12" class="pb-1 pt-0">
                <v-sheet>
                  <v-switch
                    v-model="establecer_requerimientos"
                    inset
                    label="Cargar requisitos del puesto"
                  ></v-switch>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="establecer_requerimientos">
              <v-row>
                <v-col cols="12" class="d-flex align-center pb-1 flex-wrap">
                  <span class="mr-2 body-1 font-weight-bold grey--text">Sexo</span>
                  <v-radio-group row v-model="requeriments.sexo.sexo">
                    <v-radio
                      on-icon="mdi-checkbox-blank-circle"
                      label="Indistinto"
                      value="Indistinto"
                    ></v-radio>
                    <v-radio
                      on-icon="mdi-checkbox-blank-circle"
                      label="Masculino"
                      value="Masculino"
                    ></v-radio>
                    <v-radio on-icon="mdi-checkbox-blank-circle" label="Femenino" value="Femenino"></v-radio>
                    <v-radio on-icon="mdi-checkbox-blank-circle" label="Otro" value="Otro"></v-radio>
                  </v-radio-group>
                  <v-divider></v-divider>
                  <v-checkbox
                    :disabled="requeriments.sexo.sexo === 'Indistinto' ? true : false"
                    class="ml-4"
                    label="Mandatorio"
                    v-model="requeriments.sexo.es_excluyente"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center pb-1 flex-wrap">
                  <span class="mr-2 body-1 font-weight-bold grey--text">Edad</span>
                  <span class="ml-4 mr-2 body-1 font-weight-bold grey--text">entre</span>
                  <BaseMyTextField
                    class="mt-0 pt-0"
                    hide-details
                    type="number"
                    style="max-width: 80px"
                    v-model="requeriments.edad.edad_min"
                  ></BaseMyTextField>
                  <span class="mx-4 body-1 font-weight-bold grey--text">y</span>
                  <BaseMyTextField
                    class="mt-0 pt-0"
                    hide-details
                    type="number"
                    style="max-width: 80px"
                    v-model="requeriments.edad.edad_max"
                  ></BaseMyTextField>
                  <span class="mr-4 ml-2 body-1 font-weight-bold grey--text">años</span>
                  <v-divider></v-divider>
                  <v-checkbox
                    :disabled="(requeriments.edad.edad_max && requeriments.edad.edad_min) ? false : true"
                    label="Mandatorio"
                    class="ml-4"
                    v-model="requeriments.edad.es_excluyente"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center pb-1 flex-wrap">
                  <span class="mr-4 body-1 font-weight-bold grey--text">Experiencia Minima</span>
                  <BaseMyTextField
                    type="number"
                    min="0"
                    style="max-width: 80px"
                    v-model="requeriments.experiencia.experiencia_minima"
                  ></BaseMyTextField>
                  <span class="mr-4 ml-2 body-1 font-weight-bold grey--text">años</span>
                  <v-divider></v-divider>
                  <v-checkbox
                    :disabled="requeriments.experiencia.experiencia_minima > 0 ? false : true"
                    class="ml-4"
                    label="Mandatorio"
                    v-model="requeriments.experiencia.es_excluyente"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center pb-1 flex-wrap">
                  <span class="mr-4 body-1 font-weight-bold grey--text">Salario</span>
                  <span class="mr-4 ml-2 body-1 font-weight-bold grey--text">entre</span>
                  <BaseMyTextField
                    class="mt-0 pt-0"
                    hide-details
                    type="number"
                    style="max-width: 120px"
                    v-model="requeriments.salario.salario_min"
                  ></BaseMyTextField>
                  <span class="mx-4 body-1 font-weight-bold grey--text">y</span>
                  <BaseMyTextField
                    class="mt-0 pt-0 mr-4"
                    hide-details
                    type="number"
                    style="max-width: 120px"
                    v-model="requeriments.salario.salario_max"
                  ></BaseMyTextField>
                  <v-divider></v-divider>
                  <v-checkbox
                    :disabled="requeriments.salario.salario_min && requeriments.salario.salario_max ? false : true"
                    class="ml-4"
                    label="Mostrar en el aviso"
                    v-model="requeriments.salario.mostrar"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center pb-1 flex-wrap">
                  <v-sheet class="mr-4">
                    <v-switch
                      inset
                      label="Solicitar remuneracion pretendida"
                      v-model="requeriments.remuneracion.remuneracion_pretendida"
                    ></v-switch>
                  </v-sheet>
                  <v-divider></v-divider>
                  <v-checkbox
                    :disabled="!requeriments.remuneracion.remuneracion_pretendida"
                    class="ml-4"
                    label="Mandatorio"
                    v-model="requeriments.remuneracion.es_excluyente"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center pt-6">
                  <span class="mr-4 font-weight-ligth primary--text headline">Nivel Educativo</span>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center pb-1 flex-wrap">
                  <BaseMySelect
                    :items="studyLevel"
                    v-model="requeriments.educacion.nivel_educativo"
                    label="Nivel educativo"
                    class="mr-2"
                    style="max-width: 250px"
                  ></BaseMySelect>
                  <BaseMySelect
                    v-model="requeriments.educacion.estado"
                    :items="studyState"
                    label="Estado"
                    class="mr-4"
                    style="max-width: 250px"
                  ></BaseMySelect>
                  <v-divider></v-divider>
                  <v-btn
                    text
                    color="error"
                    class="mx-2"
                    :disabled="requeriments.educacion.nivel_educativo || requeriments.educacion.estado ? false : true"
                    @click="requeriments.educacion.nivel_educativo = ''; requeriments.educacion.estado = ''; requeriments.educacion.es_excluyente = false"
                  >
                    <v-icon class="mr-2">mdi-trash-can</v-icon>Eliminar
                  </v-btn>
                  <v-checkbox
                    :disabled="requeriments.educacion.nivel_educativo && requeriments.educacion.estado ? false : true"
                    class="ml-4"
                    label="Mandatorio"
                    v-model="requeriments.educacion.es_excluyente"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center">
                  <span class="mr-4 font-weight-ligth primary--text headline">Idiomas</span>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="d-flex align-center pb-1 flex-wrap"
                  v-for="(idioma, index) in requeriments.idiomas"
                >
                  <BaseMySelect
                    v-model="idioma.idioma"
                    :items="languages"
                    label="Idioma"
                    class="mr-2"
                    style="max-width: 250px"
                  ></BaseMySelect>
                  <BaseMySelect
                    v-model="idioma.nivel"
                    :items="languageLevel"
                    label="Nivel"
                    class="mr-4"
                    style="max-width: 250px"
                  ></BaseMySelect>
                  <v-divider></v-divider>
                  <v-btn
                    text
                    color="error"
                    class="mx-2"
                    :disabled="requeriments.idiomas.length === 1"
                    @click="requeriments.idiomas.splice(index, 1)"
                  >
                    <v-icon class="mr-2">mdi-trash-can</v-icon>Eliminar
                  </v-btn>
                  <v-checkbox
                    label="Mandatorio"
                    v-model="idioma.es_excluyente"
                    :value="idioma.idioma === 'Indistinto' ? idioma.es_excluyente = false : idioma.es_excluyente"
                    :disabled="idioma.idioma === 'Indistinto'"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-btn text color="primary" @click="addLanguage">
                    <v-icon>mdi-plus</v-icon>Agregar Idioma
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-stepper-content>
      </v-stepper>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="flex-wrap">
      <span class="body-2 grey--text text--darken-1">
        <span class="font-weight-bold">*</span>
        Indica los campos obligatorios
      </span>
      <v-spacer></v-spacer>
      <div class="d-flex flex-wrap">
        <BaseMyButton class="mr-2 mb-2" color="error" @click="e1--" v-if="e1>1">Regresar</BaseMyButton>
        <BaseMyButton class="mr-2" color="info" @click="e1++" v-if="e1<3">Continuar</BaseMyButton>
        <BaseMyButton
          :disabled="validateAll || loading"
          class="mt-0"
          color="success"
          v-if="e1===3 || e1==='3'"
          :background-color="validateAll ? 'grey lighten-1' : 'success'"
          @click="addNotice()"
          :loading="loading"
        >Publicar aviso</BaseMyButton>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VueEditor } from "vue2-editor";

import { validationMixin } from "vuelidate";
import { required, integer } from "vuelidate/lib/validators";

import store from "@/store";
import { mapState } from "vuex";

export default {
  components: {
    VueEditor
  },
  mixins: [validationMixin],
  validations() {
    const notice = {
      titulo: { required },
      pais: { required },
      provincia: { required },
      ciudad: { required },
      area: { required },
      // subarea: { required },
      // nivel: { required },
      tipo_trabajo: { required },
      vacantes: { required, integer }
    };
    return { notice };
  },
  data() {
    return {
      e1: 1,
      loading: false,
      descripcionValid: true,
      notice: {
        titulo: "",
        descripcion: "",
        permitir_discapacitados: false,
        pais: "Ecuador",
        provincia: "",
        ciudad: "",
        direccion: "",
        area: "",
        // subarea: "",
        // nivel: "",
        tipo_trabajo: "",
        vacantes: "",
        preguntas: []
      },
      requeriments: {
        sexo: {
          sexo: "Indistinto",
          es_excluyente: false
        },
        edad: {
          edad_min: "",
          edad_max: "",
          es_excluyente: false
        },
        experiencia: {
          experiencia_minima: "",
          es_excluyente: false
        },
        salario: {
          salario_min: "",
          salario_max: "",
          mostrar: false
        },
        remuneracion: {
          remuneracion_pretendida: false,
          es_excluyente: false
        },
        educacion: {
          nivel_educativo: "",
          estado: "",
          es_excluyente: false
        },
        idiomas: [
          {
            idioma: "Indistinto",
            nivel: "Básico",
            es_excluyente: false
          }
        ]
      },
      requerimentsDefault: {
        sexo: {
          sexo: "",
          es_excluyente: false
        },
        edad: {
          edad_min: "",
          edad_max: "",
          es_excluyente: false
        },
        experiencia: {
          experiencia_minima: "",
          es_excluyente: false
        },
        salario: {
          salario_min: "",
          salario_max: "",
          mostrar: false
        },
        remuneracion: {
          remuneracion_pretendida: false,
          es_excluyente: false
        },
        educacion: {
          nivel_educativo: "",
          estado: "",
          es_excluyente: false
        },
        idiomas: [
          {
            idioma: "Indistinto",
            nivel: "Básico",
            es_excluyente: false
          }
        ]
      },
      establecer_requerimientos: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ]
      ],
      provinces: [],
      cities: [],
      countries: [],
      subareas: [],
      multipleOptions: ["", ""],
      questionTypeSelected: "Sin preguntas",
      questionType: [
        "Sin preguntas",
        "Predefinida",
        "Abierta",
        "Opción multiple"
      ],
      questionToAdd: "",
      questions: [
        "¿Cuál es tu expectativa salarial neta para un cambio?",
        "¿Cuál es tu expectativa salarial bruta para un cambio?",
        "¿Cuál es tu disponibilidad para comenzar a trabajar con nosotros?",
        "¿Cuentas con movilidad propia?",
        "¿Posees licencia para conducir? Aclara que tipo de vehículos",
        "¿Estarías dispuesto a trabajar en turnos rotativos?"
      ],
      jobTypes: [
        "Full-time",
        "Part-time",
        "Temporario",
        "Pasantia",
        "Por Contrato",
        "Voluntario",
        "Primer Empleo",
        "Por Horas",
        "Fines de Semana",
        "Teletrabajo"
      ],
      levels: [
        "Senior/Semi-Senior",
        "Junior",
        "Gerencia/Alta Gerencia/Dirección",
        "Jefe/Supervisor/Responsable",
        "Otro",
        "Primer Empleo"
      ],
      languages: [
        "Indistinto",
        "Ingles",
        "Español",
        "Coreano",
        "Japones",
        "Francés",
        "Italiano",
        "Holandés"
      ],
      languageLevel: ["Básico", "Avanzado", "Intermedio", "Nativo"],
      studyLevel: [
        "Secundario",
        "Terciario",
        "Universitario",
        "Posgrado",
        "Master",
        "Doctorado",
        "Otro"
      ],
      studyState: ["En Curso", "Graduado"]
    };
  },
  computed: {
    ...mapState("administration/selectsData", ["workAreas"]),
    validateAll() {
      if (!this.$v.$invalid && this.isValid) return false;
      return true;
    },
    isValid() {
      if (!this.descripcionValidation) return false;
      if (this.establecer_requerimientos) {
        if (!this.edadValidation || !this.salarioValidation) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    multipleOptionValidation() {
      if (this.questionTypeSelected !== "Opción multiple") return true;
      let response = true;
      this.multipleOptions.forEach(option => {
        if (!option) {
          response = false;
        }
      });
      return response;
    },
    descripcionValidation() {
      if (!this.notice.descripcion) return false;
      return true;
    },
    edadValidation() {
      if (this.requeriments.edad.edad_min && !this.requeriments.edad.edad_max) {
        return false;
      } else if (
        !this.requeriments.edad.edad_min &&
        this.requeriments.edad.edad_max
      ) {
        return false;
      } else if (
        parseInt(this.requeriments.edad.edad_max) <=
        parseInt(this.requeriments.edad.edad_min)
      ) {
        return false;
      } else {
        return true;
      }
    },
    salarioValidation() {
      if (
        this.requeriments.salario.salario_min &&
        !this.requeriments.salario.salario_max
      ) {
        return false;
      } else if (
        !this.requeriments.salario.salario_min &&
        this.requeriments.salario.salario_max
      ) {
        return false;
      } else if (
        parseInt(this.requeriments.salario.salario_max) <=
        parseInt(this.requeriments.salario.salario_min)
      ) {
        return false;
      } else {
        return true;
      }
    },
    predefinedQuestionsFiltered() {
      const filter = this.questions.filter(
        p => !this.notice.preguntas.some(({ pregunta }) => pregunta === p)
      );
      return filter;
    },
    // Validations Form
    tituloErrors() {
      const errors = [];
      if (!this.$v.notice.titulo.$dirty) return errors;
      !this.$v.notice.titulo.required && errors.push("Campo obligatorio");
      return errors;
    },
    paisErrors() {
      const errors = [];
      if (!this.$v.notice.pais.$dirty) return errors;
      !this.$v.notice.pais.required && errors.push("Campo obligatorio");
      return errors;
    },
    provinciaErrors() {
      const errors = [];
      if (!this.$v.notice.provincia.$dirty) return errors;
      !this.$v.notice.provincia.required && errors.push("Campo obligatorio");
      return errors;
    },
    ciudadErrors() {
      const errors = [];
      if (!this.$v.notice.ciudad.$dirty) return errors;
      !this.$v.notice.ciudad.required && errors.push("Campo obligatorio");
      return errors;
    },
    areaErrors() {
      const errors = [];
      if (!this.$v.notice.area.$dirty) return errors;
      !this.$v.notice.area.required && errors.push("Campo obligatorio");
      return errors;
    },
    subareaErrors() {
      const errors = [];
      if (!this.$v.notice.subarea.$dirty) return errors;
      !this.$v.notice.subarea.required && errors.push("Campo obligatorio");
      return errors;
    },
    nivelErrors() {
      const errors = [];
      if (!this.$v.notice.nivel.$dirty) return errors;
      !this.$v.notice.nivel.required && errors.push("Campo obligatorio");
      return errors;
    },
    tipoTrabajoErrors() {
      const errors = [];
      if (!this.$v.notice.tipo_trabajo.$dirty) return errors;
      !this.$v.notice.tipo_trabajo.required && errors.push("Campo obligatorio");
      return errors;
    },
    vacantesErrors() {
      const errors = [];
      if (!this.$v.notice.vacantes.$dirty) return errors;
      !this.$v.notice.vacantes.required && errors.push("Campo obligatorio");
      return errors;
    }
  },
  created() {
    this.retrieveCountries();
    this.retrieveSelectsData();
  },
  methods: {
    retrieveSelectsData() {
      this.$store.dispatch("administration/selectsData/retrieveWorkAreas");
    },
    retrieveSubarea(area) {
      const filter = this.workAreas.filter(
        studyArea => studyArea.area === area
      );
      if (filter[0]) {
        this.subareas = filter[0].subareas;
      } else {
        this.subareas = [];
      }
    },
    descripcionChange() {
      if (!this.notice.descripcion) {
        this.descripcionValid = false;
      } else {
        this.descripcionValid = true;
      }
    },
    addNotice() {
      this.loading = true;
      if (this.establecer_requerimientos) {
        if (this.requeriments.sexo.sexo === "Indistinto") {
          delete this.requeriments.sexo;
        }
        if (this.requeriments.edad) {
          if (
            !this.requeriments.edad.edad_min ||
            !this.requeriments.edad.edad_max
          ) {
            delete this.requeriments.edad;
          }
        }
        if (this.requeriments.experiencia) {
          if (!this.requeriments.experiencia.experiencia_minima) {
            delete this.requeriments.experiencia;
          }
        }
        if (this.requeriments.salario) {
          if (
            !this.requeriments.salario.salario_min ||
            !this.requeriments.salario.salario_max
          ) {
            delete this.requeriments.salario;
          }
        }
        if (this.requeriments.remuneracion) {
          if (!this.requeriments.remuneracion.remuneracion_pretendida) {
            delete this.requeriments.remuneracion;
          }
        }
        if (this.requeriments.educacion) {
          if (!this.requeriments.educacion.nivel_educativo) {
            delete this.requeriments.educacion;
          }
        }
        if (this.requeriments.idiomas[0].idioma === "Indistinto") {
          delete this.requeriments.idiomas;
        }
        this.notice.requerimientos = this.requeriments;
      }
      store
        .dispatch("companies/notices/addNotice", this.notice)
        .then(response => {
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Aviso agregado",
            visible: true
          });
          this.closeDialog();
        })
        .catch(error => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al agregar aviso",
            visible: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addQuestion() {
      const questionToPush = {
        pregunta: this.questionToAdd,
        tipo: this.questionTypeSelected
      };
      if (this.questionTypeSelected === "Opción multiple") {
        questionToPush.opciones = this.multipleOptions;
      }
      this.notice.preguntas.push(questionToPush);
      this.cancelAddQuestion();
    },
    addLanguage() {
      this.requeriments.idiomas.push({
        idioma: "Indistinto",
        nivel: "Básico",
        es_excluyente: false
      });
    },
    addMultipleOption() {
      this.multipleOptions.push("");
    },
    cancelAddQuestion() {
      this.questionTypeSelected = "Sin preguntas";
      this.questionToAdd = "";
      this.multipleOptions = ["", ""];
    },
    closeDialog() {
      this.requeriments = JSON.parse(JSON.stringify(this.requerimentsDefault));
      this.$emit("closeDialog");
    },
    retrieveCountries() {
      this.loadingCountries = true;
      this.$store
        .dispatch("retriveCountries")
        .then(data => {
          this.countries = data;
          if (this.notice.pais) this.retriveProvincias(this.notice.pais);
        })
        .catch(err => {
          // console.log(err.response);
        })
        .finally(() => {
          this.loadingCountries = false;
        });
    },
    retriveProvincias(countryName) {
      this.loadingProvinces = true;
      const country = this.countries.find(
        country => country.name === countryName
      );

      this.$store
        .dispatch("retriveProvincias", country.id)
        .then(data => {
          this.provinces = data;
          if (this.notice.provincia)
            this.retriveCities(this.notice.pais, this.notice.provincia);
        })
        .catch(err => {
          // console.log(err.response);
        })
        .finally(() => {
          this.loadingProvinces = false;
        });
    },
    retriveCities(countryName, provinceName) {
      this.loadingProvinces = true;
      const country = this.countries.find(
        country => country.name === countryName
      );
      const province = this.provinces.find(
        province => province.name === provinceName
      );

      this.$store
        .dispatch("retriveCities", {
          country: country.id,
          province: province.id
        })
        .then(data => {
          this.cities = data;
        })
        .catch(err => {
          // console.log(err.response);
        })
        .finally(() => {
          this.loadingProvinces = false;
        });
    }
  }
};
</script>